import React, { useState } from 'react';
import { Code } from 'lucide-react';

interface ThinkingDisplayProps {
  thinking: string;
}

const ThinkingDisplay = React.memo(function ThinkingDisplay({ thinking }: ThinkingDisplayProps) {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="mt-3 bg-purple-50 border border-purple-200 rounded-lg p-2">
      <button
        onClick={() => setExpanded(!expanded)}
        type="button"
        className="flex items-center gap-2 text-xs text-purple-900 font-semibold w-full focus:outline-2 focus:outline-blue-500"
        aria-expanded={expanded}
        aria-label={expanded ? 'Collapse agent reasoning' : 'Expand agent reasoning'}
      >
        <Code className="w-3 h-3" />
        <span>Agent Reasoning</span>
        <span className="ml-auto">{expanded ? '\u2212' : '+'}</span>
      </button>
      {expanded && (
        <div className="mt-2 text-xs text-purple-800 whitespace-pre-wrap">{thinking}</div>
      )}
    </div>
  );
});

export default ThinkingDisplay;
